import Api from "../../utils/api";
import { API_URLS } from "../../utils/api.urls";

export const fetchSocialMedia = async (params: any): Promise<any> => {
  const data = await Api.get(API_URLS.SOCIAL_MEDIA_CRUD, []);
  return data;
};
